<template>
  <div class="childtrackingsystem-analyse">
    <div class="row bg-white">
      <br>
    </div>
    <div v-if="!isAnalyse && !isContent">
      <div class="row bg-white pt-1 pb-1">
        <div class="col-md-2">
          <strong>Mentor</strong>
        </div>
        <div class="col-md-4">
          <select
              id="mentor"
              v-model="selectedMentor"
              class="form-select form-select-sm"
              name="mentor"
              style="width:300px; color: #666;"
              @change="mentorChanged($event)"
          >
            <option value="0" selected>Alle</option>
            <option
                v-for="mentor in mentors"
                :key="mentor.id"
                :value="mentor.id"
            >
              {{ mentor.name }}
            </option>
          </select>
        </div>
        <div class="col-md-1">
          <strong>Leeftijd</strong>
        </div>
        <div class="col-md-5">
          <select
              id="age"
              v-model="selectedAge"
              class="form-select form-select-sm"
              name="age"
              style="width:400px; color: #666;"
              @change="ageChanged($event)"
          >
            <option value="0" selected>Alle</option>
            <option
                v-for="age in ages"
                :key="age.id"
                :value="age.id"
            >
              {{ age.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="row bg-white pt-1 pb-1">
        <div class="col-md-2">
          <strong>Ontwikkelingsgebied</strong>
        </div>
        <div class="col-md-4">
          <select
              id="idCategory"
              v-model="selectedCategory"
              class="form-select form-select-sm"
              name="idCategory"
              style="width:300px; color: #666;"
              @change="categoryChanged($event)"
          >
            <option value="0" selected>Alle</option>
            <option
                v-for="category in categories"
                :key="category.id"
                :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
        <div class="col-md-1">
          <strong>Doelen</strong>
        </div>
        <div class="col-md-5">
          <select
              id="idQuestion"
              v-model="selectedQuestion"
              class="form-select form-select-sm"
              name="idQuestion"
              style="width:400px; color: #666;"
              @change="questionChanged($event)"
          >
            <option value="0" selected>Alle</option>
            <option
                v-for="question in questions"
                :key="question.id"
                :value="question.id"
            >
              {{ question.vraag }}
            </option>
          </select>
        </div>
      </div>
      <div class="row bg-white pt-1 pb-1">
        <div class="col-md-2">
          <strong>Filter kinderen</strong>
        </div>
        <div class="col-md-4">
          <select
              id="filterChildren"
              v-model="filterChildren"
              class="form-select form-select-sm"
              name="filterChildren"
              style="width:300px; color: #666;"
              @change="doFilterChildren($event)"
          >
            <option value="all">Alle</option>
            <option value="present">Aanwezig</option>
            <option value="vve">VVE</option>
          </select>
          </div>
        </div>
      <div class="row bg-white">
        <div class="col-md-12">
          <br>
        </div>
      </div><div class="row bg-white">
        <div class="col-md-12" />
      </div>
      <div class="row bg-white">
        <br>
        <div class="col-md-6">
          <div class="search-filter">
            <input
              id="searchChild"
              v-model="searchChild"
              type="text"
              name="searchChild"
              placeholder="Zoek kind"
              value=""
              class="form-control table-search"
            >
          </div>
          <div style="height: 490px; overflow:auto;">
          <ul class="list-group">
            <li
              v-for="child in filteredRows"
              :key="child.id"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              <div>
                <input
                  v-model="checkedChildren"
                  type="checkbox"
                  name="children"
                  :value="child.id"
                  @input="reloadObservationLists($event, child.age)"
                >{{ child.full_name }} ({{ child.birthday }})
              </div>
              <small>
                <span
                  v-if="child.alertCTS"
                  @click="viewAnalyse(child.idResult);"
                >
                  <icon name="look-into" :fontSize="'1rem'"></icon>
                </span>
                {{ child.age }} mnd
              </small>
            </li>
          </ul>
            </div>
          <br><br>
        </div>
        <div class="col-md-6">
          <div style="padding-top: 20px;">
          <input type="checkbox"

                 name="loadAllLists"
                 value="loadAllLists" @change="loadAllLists($event)" /> Laad alle observatielijsten</div>
          <ul
            class="list-group"
            style="padding-top: 10px;"
          >
            <li
              v-for="(list, index) in results"
              :key="index"
              class="list-group-item"
            >
              <input
                v-model="checkedList"
                type="radio"
                name="observationList"
                :value="list.id"
              >{{ list.titel }}
            </li>
          </ul>
          <div style="width:100%; margin-top:10px; margin-right:3px; text-align: right;">
            <button
              class="btn btn-outline-primary"
              @click="analyseChildren()"
            >
              Observeren
            </button><br>
          </div>
          <br><br>
        </div>
      </div>
    </div>
    <div v-if="isAnalyse">
      <childtrackingsystem-analysechild
        :checked-children="checkedChildren"
        :checked-list="checkedList"
        :checked-category="selectedCategory"
        :checked-question="selectedQuestion"
      />
    </div>
    <div
      v-if="isContent"
      class="row bg-white"
    >
      <div class="col-md-12">
        <childtrackingsystem-editchildobservationlist
          :idResult="idResult"
        />
      </div>
    </div>
    <div
      v-if="isLoading"
      class="modalLoader"
    >
      <img
        src="../../assets/img/loading.gif"
        alt="Loading"
        style="width: 80px; height: 80px;"
      >
    </div>
  </div>
</template>
<script>
import ChildtrackingsystemAnalysechild from "./AnalyseChild";
import ChildtrackingsystemEditchildobservationlist from "./EditObservationList";
import Icon from "@/components/Icon";

export default {
        name: 'ChildtrackingsystemAnalyse',
        components: {
            ChildtrackingsystemEditchildobservationlist,
            ChildtrackingsystemAnalysechild,
            Icon
        },
        data() {
            return {
                isLoading: false,
                isAnalyse: false,
                results: [],
                ages: [],
                selectedAge: 0,
                mentors: [],
                childrenCTS: [],
                selectedMentor: 0,
                searchChild: null,
                checkedList: 0,
                checkedChildren: [],
                analysedChildren: [],
                selectedCategory: 0,
                categories: [],
                selAge: [],
                selectedQuestion: 0,
                questions: [],
                isContent: false,
                idResult: 0,
                idList: 0,
                idCategory: 0,
                idChild: 0,
                filterChildren: 'all'
            }
        },
        computed: {
            deviceToken() {
                return this.$store.getters.deviceToken
            },
            session() {
                return this.$store.getters.session
            },
            filteredRows() {
                return this.searchChild ? this.childrenCTS.filter(child => child.full_name.toLowerCase().includes(this.searchChild.toLowerCase())) : this.childrenCTS
            }
        },
        created() {
            window.novict = {
                device: {
                    device_token: this.deviceToken
                },
                session: {
                    session_token: this.session.session_token
                }
            }
            this.getResults()
        },
        methods: {
            ageChanged(event) {
                this.selectedAge = event.target.value
                this.getResults()
                return event.target.value
            },
            mentorChanged(event) {
                this.selectedMentor = event.target.value
                this.getResults()
                return event.target.value
            },
            categoryChanged(event) {
                this.selectedCategory = event.target.value
                this.getQuestions()
                this.getResults()
            },
            questionChanged (event) {
                 this.selectedQuestion = event.target.value
                 this.getResults()
            },
           loadAllLists(event) {
             let childAge = false
             if (!event.target.checked) {
               childAge = this.selAge.join(',')
             }
             this.$store.commit('REGISTER_ACTIVE_REQUEST')
               // eslint-disable-next-line no-undef
             this.$request.post( '/ChildTrackingSystem/observationLists', {
                 idEstablishment: this.$store.getters.selectedEstablishment.id,
                 idGroup: this.$store.getters.selectedGroupsQueryString,
                 selectedAge: false,
                 selectedMentor: this.selectedMentor,
                 selectedCategory: this.selectedCategory,
                 selAgeChild: childAge,
                 ipad: true
               }).then((response) => {
                 this.$store.commit('REMOVE_ACTIVE_REQUEST')
                 if (response) {
                   this.results = response.observationLists
                 }
               })
           },
            reloadObservationLists(event, childAge) {
                if (event.target.checked) {
                    this.selAge.push(childAge)
                } else {
                    let index = this.selAge.indexOf(childAge)
                    if (index > -1) {
                        this.selAge.splice(index, 1)
                    }
                }
                this.$store.commit('REGISTER_ACTIVE_REQUEST')
              // eslint-disable-next-line no-undef
                this.$request.post( '/ChildTrackingSystem/observationLists', {
                    idEstablishment: this.$store.getters.selectedEstablishment.id,
                    idGroup: this.$store.getters.selectedGroupsQueryString, // @todo Fix for all groups,
                    selectedAge: this.selectedAge,
                    selectedMentor: this.selectedMentor,
                    selectedCategory: this.selectedCategory,
                    selAgeChild: this.selAge.join(','),
                    ipad: true
                }).then((response) => {
                    this.$store.commit('REMOVE_ACTIVE_REQUEST')
                    if (response) {
                        this.results = response.observationLists
                    }
                })
            },
            getResults() {
                this.isLoading = true
                this.$store.commit('REGISTER_ACTIVE_REQUEST')
              // eslint-disable-next-line no-undef
              this.$request.post( '/ChildTrackingSystem/analyse', {
                    idEstablishment: this.$store.getters.selectedEstablishment.id,
                    idChild: this.$store.getters.selectedChild,
                    idGroup: this.$store.getters.selectedGroupsQueryString,
                    selectedAge: this.selectedAge,
                    idMentor: this.selectedMentor,
                    idCategory: this.selectedCategory,
                    idQuestion: this.selectedQuestion,
                    ipad: true,
                    showPresentOnly: this.$store.getters.showPresentChildrenOnly
                }).then((response) => {
                    this.isLoading = false
                    this.$store.commit('REMOVE_ACTIVE_REQUEST')
                    if (response) {
                        this.results = response.lists
                        this.ages = response.ages
                        this.mentors = response.mentors
                        this.childrenCTS = response.children
                        this.categories = response.categories
                    }
                })
            },
            getQuestions() {
                this.isLoading = true
                this.$store.commit('REGISTER_ACTIVE_REQUEST')
              // eslint-disable-next-line no-undef
                this.$request.post('/ChildTrackingSystem/getQuestions', {
                  idCategory: this.selectedCategory,
                  selectedAge: this.selectedAge,
                  ipad: true
                }).then((response) => {
                  this.isLoading = false
                  this.$store.commit('REMOVE_ACTIVE_REQUEST')
                  if (response) {
                    this.questions = response.questions
                  }
                })
            },
            analyseChildren() {
                if (this.checkedChildren.length === 0) {
                  alert("Kies de kind(eren) die u wilt observeren!");
                } else if (this.checkedList === 0) {
                  alert("Kies een observatielijst!");
                } else {
                  this.$store.commit('REGISTER_ACTIVE_REQUEST')
                  // eslint-disable-next-line no-undef
                  this.$request.post('/ChildTrackingSystem/getAnalysedChildren', {
                    checkedChildren: this.checkedChildren,
                    checkedList: this.checkedList
                  }).then((response) => {
                    this.isLoading = false
                    this.$store.commit('REMOVE_ACTIVE_REQUEST')
                    if (response.analysedChildren.length > 0) {
                      if (confirm(response.analysedChildren)) {
                        if (response.checkedChildren.length > 0) {
                          this.checkedChildren = response.checkedChildren;
                          this.isAnalyse = true
                        }
                      }
                    } else {
                      this.isAnalyse = true
                    }
                  })
                }
            },
            doFilterChildren(event) {
              this.filterChildren = event.target.value
              this.isLoading = true
              this.$store.commit('REGISTER_ACTIVE_REQUEST')
              // eslint-disable-next-line no-undef
              this.$request.post('/ChildTrackingSystem/getChildren', {
                filterChildren: this.filterChildren,
                idEstablishment: this.$store.getters.selectedEstablishment.id,
                idChild: this.$store.getters.selectedChild,
                idGroup: this.$store.getters.selectedGroupsQueryString,
                selectedAge: this.selectedAge,
                selectedMentor: this.selectedMentor
              }).then((response) => {
                this.isLoading = false
                this.$store.commit('REMOVE_ACTIVE_REQUEST')
                if (response) {
                  this.childrenCTS = response.children
                }
              })
              return event.target.value
            },
           viewAnalyse (idResult) {
             this.idResult = idResult
             this.isContent = true
           }
        }
    }
</script>
<style scoped>
    .table th {
      color: #445161;
      background-color: #dedee7;
      border-top: 1px solid #ddd !important;
    }

    .table td {
      border-bottom: 1px solid #ddd !important;
      color: #666;
    }
    .search-filter {
        color: #666;
        height: 50px;
    }
    .table-search {
      margin-top: 5px;
      width: 100%;
      color: #666;
    }
    .modalLoader {
        position: absolute;
        z-index: 1;
        left: 0;
        top: 100px;
        width: 100%;
        height: 100%;
        overflow: auto;
    }
    input[type=checkbox] {
      transform: scale(1.5,1.5);
      margin-right: 15px;
    }
    input[type=radio] {
      transform: scale(1.5,1.5);
      margin-right: 15px;
    }
    .grey {
      color: #666;
      font-size: 15px;
      margin-right: 5px;
    }
</style>